'use es6';

import PropTypes from 'prop-types';
import Immutable from 'immutable';
import classnames from 'classnames';
import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import UILink from 'UIComponents/link/UILink';
import { removeLeadingSlashFromPath } from 'FileManagerCore/utils/stringUtils';
import UsageTracker from '../utils/usageTracker';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { jsx as _jsx } from "react/jsx-runtime";
const FileFolderRowPath = ({
  className,
  object,
  ancestorFolders,
  navigateToFolder
}) => {
  const parentFolderId = object.get('folder_id') || object.get('parent_folder_id');
  if (!parentFolderId) {
    return null;
  }
  let ancestorPathItems;
  if (ancestorFolders) {
    ancestorPathItems = ancestorFolders.toArray().map(folder => ({
      name: folder.get('name'),
      folderId: folder.get('id')
    }));
  } else if (object.get('full_path')) {
    const fullPath = removeLeadingSlashFromPath(object.get('full_path'));
    const pathParts = fullPath.split('/');
    pathParts.pop();
    ancestorPathItems = pathParts.map((part, i) => {
      return {
        name: part,
        folderId: i === pathParts.length - 1 ? parentFolderId : null
      };
    });
  } else {
    return null;
  }
  const renderFolder = ({
    name,
    folderId
  }, i) => {
    const handleClick = () => {
      UsageTracker.track('fileManagerExploreFiles', {
        action: 'click-folder-breadcrumb',
        target: ancestorFolders ? 'details-panel' : 'file-folder-row'
      });
      navigateToFolder(folderId);
    };
    if (!folderId) {
      return /*#__PURE__*/_jsx(UILink, {
        use: "unstyled",
        children: /*#__PURE__*/_jsx(UITruncateString, {
          children: name
        })
      }, i);
    }
    return /*#__PURE__*/_jsx(UILink, {
      onClick: handleClick,
      children: /*#__PURE__*/_jsx(UITruncateString, {
        children: name
      })
    }, i);
  };
  return /*#__PURE__*/_jsx(UIBreadcrumbs, {
    "data-test-id": "file-folder-row-path",
    className: classnames('m-all-0', className),
    flush: true,
    truncateToLevels: ancestorFolders ? null : 1,
    singleBreadcrumbIsBackLink: false,
    wrapLevels: true,
    onClick: e => e.stopPropagation(),
    children: ancestorPathItems.map(renderFolder)
  });
};
FileFolderRowPath.propTypes = {
  className: PropTypes.string,
  object: PropTypes.instanceOf(Immutable.Map).isRequired,
  ancestorFolders: PropTypes.instanceOf(Immutable.OrderedMap),
  navigateToFolder: PropTypes.func.isRequired
};
export default FileFolderRowPath;